const UNITS: Array<[number, string]> = [
  [365 * 864e5, 'y'],
  [30 * 864e5, 'mo'],
  [7 * 864e5, 'w'],
  [864e5, 'd'],
  [36e5, 'h'],
  [6e4, 'm'],
  [1e3, 's'],
];

export const shortAgo = (date: Date | string | number, now: number = Date.now()): string => {
  const time = new Date(date).getTime();
  if (Number.isNaN(time)) {
    return date?.toLocaleString() ?? '';
  }

  const diff = now - time;
  if (diff < 0) return 'now';

  for (const [ms, unit] of UNITS) {
    const value = Math.floor(diff / ms);
    if (value >= 1) return `${value}${unit} ago`;
  }

  return 'now';
};

/**
 * Formats a duration in milliseconds as HH:MM:SS.
 * Negative or invalid inputs are clamped to 00:00:00.
 */
export const formatDuration = (ms: number): string => {
  const totalSeconds = Number.isFinite(ms) && ms > 0 ? Math.floor(ms / 1000) : 0;
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};
